<template>
  <fm-modal title="提交" v-model="modal" width="600px" v-if="modal">
    <fm-form label-align="left">
      <fm-form-item label="科主任" v-if="updateKeys && updateKeys.split(',').includes('orgLeadWorkerId')">
        <fm-select absolute filterable :clearable="true" v-model="formData.orgLeadWorkerId">
          <fm-option v-for="item in workerList" :key="item.key" :value="item.key" :label="item.label"></fm-option>
        </fm-select>
      </fm-form-item>
      <fm-form-item label="部门分管领导" v-if="updateKeys && updateKeys.split(',').includes('fgLeadWorkerId')">
        <fm-select absolute filterable :clearable="true" v-model="formData.fgLeadWorkerId">
          <fm-option v-for="item in workerList" :key="item.key" :value="item.key" :label="item.label"></fm-option>
        </fm-select>
      </fm-form-item>
      <fm-form-item label="人事部门领导" v-if="updateKeys && updateKeys.split(',').includes('personnelWorkerId')">
        <fm-select absolute filterable :clearable="true" v-model="formData.personnelWorkerId">
          <fm-option v-for="item in workerList" :key="item.key" :value="item.key" :label="item.label"></fm-option>
        </fm-select>
      </fm-form-item>
      <fm-form-item label="副院长" v-if="updateKeys && updateKeys.split(',').includes('associateDeanWorkerId')">
        <fm-select absolute filterable :clearable="true" v-model="formData.associateDeanWorkerId">
          <fm-option v-for="item in workerList" :key="item.key" :value="item.key" :label="item.label"></fm-option>
        </fm-select>
      </fm-form-item>
      <fm-form-item label="院长" v-if="updateKeys && updateKeys.split(',').includes('deanWorkerId')">
        <fm-select absolute filterable :clearable="true" v-model="formData.deanWorkerId">
          <fm-option v-for="item in workerList" :key="item.key" :value="item.key" :label="item.label"></fm-option>
        </fm-select>
      </fm-form-item>
    </fm-form>
    <div class="model-btn">
      <fm-btn style="margin-right: 30px;" @click="formSubmit">提交</fm-btn>
      <fm-btn @click="modal = false">取消</fm-btn>
    </div>
  </fm-modal>
</template>

<script>
export default {
  props: {
    updateKeys: { type: String, defualt: null }
  },
  data () {
    return {
      formData: {},
      modal: false
    }
  },
  computed: {
    workerList () {
      return this.$store.getters.workerList
    }
  },
  methods: {
    async formSubmit () {
      let pass = true
      this.updateKeys.split(',').forEach(v => {
        if (!this.formData[v]) {
          pass = false
        }
      })
      if (!pass) {
        this.$notify({
          title: '系统提示',
          message: '请检查表单',
          type: 'info'
        })
      } else {
        this.$emit('submit', this.formData)
        this.modal = false
      }
    }
  }
}
</script>

<style scoped lang="less">
.model-btn {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>